import { TenantSettingType, TenantSettingsDTO } from '../models/tenant.model';

export function isTenantSettingEnabled(
  settings: TenantSettingsDTO[] | null | undefined,
  type: TenantSettingType
): boolean {
  return settings?.some(setting => setting.type === type && setting.value === true) ?? false;
}
